import "./login.scss"

const AdminLogin = () => {
  return (
    <div>Login</div>
  )
}

export default AdminLogin